/* Use with care! Some scripts may not work correctly if deferred. Always test thoroughly before deploying!
 *
 * FIX 2026-08: Kollision mit Pandectes' patchCreateElement() behoben.
 *   Pandectes definiert auf jedem via document.createElement erzeugten <script>
 *   eine NON-CONFIGURABLE 'src'-Property. Ein zweites Object.defineProperties
 *   darauf wirft "Cannot redefine property: src" - und zwar mitten in Shopifys
 *   loadFeatures(), wodurch Shopify.customerPrivacy nie initialisiert wird
 *   (Folge: keine Analytics-Consent-Weitergabe -> keine Shopify-Sessions).
 *
 *   Aenderungen gegenueber der Vorversion:
 *   1. Idempotenz-Guard: Patch wird nie zweimal installiert.
 *   2. configurable/enumerable gesetzt, damit spaetere Patches nicht brechen.
 *   3. Vor dem Definieren wird geprueft, ob 'src'/'href' schon non-configurable
 *      belegt sind. Falls ja: still ueberspringen statt zu crashen (der
 *      bestehende Patch von Pandectes bleibt dabei voll funktionsfaehig).
 *   4. Kompletter Patch zusaetzlich in try/catch - Belt and braces.
 *   5. NEVER_DEFER: Shopify-eigene Analytics-Assets werden nie deferred/blockiert.
 *   6. Bugfix: data-src wurde auch bei Inline-Scripts (src === "") gesetzt,
 *      was beim Reload zu <script src=""> fuehrte.
 *   7. Bugfix: 'defer' wurde am alten statt am neuen Script-Element gesetzt.
 */

(function () {
  if (window.__deferScriptsInstalled) return;
  window.__deferScriptsInstalled = true;

  // Ressourcen, die verzoegert geladen werden sollen.
  // load: "onUserInteract" => erst nach Scroll/Klick/Touch.
  const deferredResources = [
    { "src": "youtube.com" },
    { "src": "adcell.com", "load": "onUserInteract" },
  ];

  // Ressourcen, die nur geladen werden, wenn ihr Ziel-Element existiert.
  const blockedResources = [
    {
      "key": "src",
      "val": "storelocator",
      "getShouldBlock": () => { return document.querySelector('#scasl-app-container') == null }
    },
    {
      "key": "src",
      "val": "yotpo",
      "getShouldBlock": () => { return document.querySelector('.yotpo-widget-instance, [data-yotpo-instance-id]') == null }
    }
  ];

  /* ------------------------------------------------------------------
   * NIEMALS anfassen: Shopifys eigene Analytics-/Consent-Infrastruktur.
   * Wird hier etwas deferred, brechen Shopify-Sessions und die
   * Customer Privacy API. Diese Liste bitte nicht kuerzen.
   * ------------------------------------------------------------------ */
  const NEVER_DEFER = [
    'cdn/s/trekkie',
    'cdn/wpm/',
    'web-pixels',
    'shopifycloud',
    'consent-tracking-api',
    'monorail',
    'pandectes'
  ];

  function isProtected(value) {
    if (!value || typeof value.indexOf !== 'function') return false;
    for (let i = 0; i < NEVER_DEFER.length; i++) {
      if (value.indexOf(NEVER_DEFER[i]) !== -1) return true;
    }
    return false;
  }

  function isProtectedElement(el) {
    // Shopifys Trekkie-Loader sitzt in <script class="analytics"> ohne src.
    if (el.classList && el.classList.contains('analytics')) return true;
    const src = el.getAttribute && (el.getAttribute('src') || el.getAttribute('data-src'));
    return isProtected(src);
  }

  function shouldBlockResource(resource) {
    if (isProtectedElement(resource)) return false;

    for (let i = 0; i < deferredResources.length; i++) {
      const blockedResource = deferredResources[i];
      if (window.deferredDone !== true || (blockedResource.load && !window.userInteracted)) {
        for (let key in blockedResource) {
          if (key === 'load') continue;
          if (resource[key] && resource[key].indexOf(blockedResource[key]) !== -1) {
            return blockedResource.load || true;
          }
        }
      }
    }
    for (let i = 0; i < blockedResources.length; i++) {
      const blockedResource = blockedResources[i];
      if (
        blockedResource.getShouldBlock() &&
        ((resource.hasAttribute(blockedResource.key) && resource.getAttribute(blockedResource.key).indexOf(blockedResource.val) !== -1) ||
         (resource.hasAttribute("data-" + blockedResource.key) && resource.getAttribute("data-" + blockedResource.key).indexOf(blockedResource.val) !== -1))
      ) {
        return true;
      }
    }
    return false;
  }

  function shouldBlockKeyValue(key, value) {
    if (isProtected(value)) return false;

    for (let i = 0; i < deferredResources.length; i++) {
      const blockedResource = deferredResources[i];
      if (window.deferredDone !== true || (blockedResource.load && !window.userInteracted)) {
        if (blockedResource[key] && value && value.indexOf(blockedResource[key]) !== -1) {
          return blockedResource.load || true;
        }
      }
    }
    for (let i = 0; i < blockedResources.length; i++) {
      const blockedResource = blockedResources[i];
      if (blockedResource.getShouldBlock() && blockedResource.key === key && value && value.indexOf(blockedResource.val) !== -1) {
        return true;
      }
    }
    return false;
  }

  function blockResourcesAsync() {
    const allElements = [
      ...document.querySelectorAll('script[type="text/javascript"],script:not([type])'),
      ...document.querySelectorAll('link[rel="stylesheet"]'),
      ...document.querySelectorAll('iframe')
    ];

    function processBatch(batch) {
      const chunk = batch.splice(0, 10);
      chunk.forEach((el) => {
        const shouldBlock = shouldBlockResource(el);
        if (shouldBlock) {
          if (typeof shouldBlock === "string") el.setAttribute('data-load', shouldBlock);
          if (el.tagName === "SCRIPT") {
            el.setAttribute('data-defer', "true");
            // Bugfix: nur setzen, wenn tatsaechlich ein src vorhanden ist.
            if (el.src) {
              el.setAttribute('data-src', el.src);
              el.removeAttribute('src');
            }
            el.type = "text/plain";
          } else if (el.tagName === "LINK") {
            el.setAttribute('data-href', el.href);
            el.href = '';
          } else if (el.tagName === "IFRAME") {
            if (el.src) {
              el.setAttribute('data-src', el.src);
              el.removeAttribute('src');
            }
          }
        }
      });

      if (batch.length > 0) {
        (window.requestIdleCallback || function (cb) { setTimeout(cb, 0); })(() => processBatch(batch));
      }
    }

    processBatch(allElements);
  }

  function reloadDeferredResources(load) {
    const scripts = load
      ? document.querySelectorAll(`script[data-src][data-load="${load}"],script[data-defer][data-load="${load}"]`)
      : document.querySelectorAll('script[data-src]:not([data-load]),script[data-defer]:not([data-load])');

    scripts.forEach((script) => {
      if (!shouldBlockResource(script)) {
        const newScript = document.createElement('script');
        script.getAttributeNames().forEach((key) => {
          if (key !== "data-src" && key !== "data-defer" && key !== "data-load") {
            newScript.setAttribute(key, script.getAttribute(key));
          }
        });
        if (script.hasAttribute('data-src') && script.getAttribute('data-src')) {
          // Bugfix: defer gehoert an das NEUE Element.
          if (!script.hasAttribute("defer") && !script.hasAttribute("async")) {
            newScript.setAttribute('defer', '');
          }
          newScript.src = script.getAttribute('data-src');
        } else {
          newScript.innerHTML = script.innerHTML;
        }
        newScript.type = "text/javascript";
        document.body.appendChild(newScript);
        script.remove();
      }
    });

    const stylesheets = load
      ? document.querySelectorAll(`link[rel="stylesheet"][data-href][data-load="${load}"]`)
      : document.querySelectorAll('link[rel="stylesheet"][data-href]:not([data-load])');

    stylesheets.forEach((stylesheet) => {
      const newLink = document.createElement('link');
      newLink.rel = 'stylesheet';
      newLink.href = stylesheet.getAttribute('data-href') || stylesheet.href;
      newLink.media = 'print';
      newLink.onload = function () {
        this.media = 'all';
      };
      stylesheet.parentNode.removeChild(stylesheet);
      document.body.appendChild(newLink);
    });

    const iframes = load
      ? document.querySelectorAll(`iframe[data-src][data-load="${load}"]`)
      : document.querySelectorAll('iframe[data-src]:not([data-load])');

    iframes.forEach((iframe) => {
      iframe.src = iframe.getAttribute('data-src');
      iframe.removeAttribute('data-src');
    });
  }

  function handleUserInteraction() {
    window.userInteracted = true;
    document.removeEventListener("scroll", handleUserInteraction);
    document.removeEventListener("click", handleUserInteraction);
    document.removeEventListener("touchstart", handleUserInteraction);
    setTimeout(() => {
      reloadDeferredResources("onUserInteract");
    }, 500);
  }

  /* ------------------------------------------------------------------
   * createElement-Patch - kollisionssicher.
   * ------------------------------------------------------------------ */
  function safeDefine(el, name) {
    // Falls ein anderer Patch (z. B. Pandectes) 'src' schon non-configurable
    // belegt hat: nichts tun. Dessen Blocking greift dann weiterhin, wir
    // verzichten hier lediglich auf unsere zusaetzliche Ebene.
    const existing = Object.getOwnPropertyDescriptor(el, name);
    if (existing && !existing.configurable) return false;

    const originalSetAttribute = el.setAttribute.bind(el);
    const dataKey = 'data-' + name;

    try {
      Object.defineProperty(el, name, {
        configurable: true,
        enumerable: true,
        get() { return el.getAttribute(name); },
        set(value) {
          const val = value == null ? value : value.toString();
          const shouldBlock = shouldBlockKeyValue(name, val);
          if (shouldBlock) {
            if (typeof shouldBlock === "string") originalSetAttribute('data-load', shouldBlock);
            originalSetAttribute(dataKey, val);
          } else {
            originalSetAttribute(name, val);
          }
        }
      });
      return true;
    } catch (e) {
      return false;
    }
  }

  const createElementBackup = document.createElement;
  document.createElement = function (...args) {
    const tag = String(args[0]).toLowerCase();
    if (tag !== 'script' && tag !== 'iframe') {
      return createElementBackup.bind(document)(...args);
    }

    const el = createElementBackup.bind(document)(...args);

    try {
      const patched = safeDefine(el, 'src');
      if (patched) {
        el.setAttribute = function (name, value) {
          if (name === 'src') {
            el[name] = value;
          } else {
            (tag === 'script' ? HTMLScriptElement : HTMLIFrameElement).prototype.setAttribute.call(el, name, value);
          }
        };
      }
    } catch (e) {
      // Niemals den Aufrufer mitreissen - insbesondere nicht Shopifys loadFeatures().
      if (window.console && console.warn) {
        console.warn('[defer-scripts] createElement patch skipped:', e && e.message);
      }
    }

    return el;
  };

  blockResourcesAsync();

  document.onreadystatechange = function () {
    if (document.readyState === 'interactive') {
      blockResourcesAsync();
    }
    if (document.querySelector("[data-load]")) {
      document.addEventListener("scroll", handleUserInteraction, { passive: true });
      document.addEventListener("touchstart", handleUserInteraction, { passive: true });
      document.addEventListener("click", handleUserInteraction);
    }
  };

  window.addEventListener("DOMContentLoaded", function () {
    window.deferredDone = true;
    reloadDeferredResources();
  });

})();